// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__35n-J","info":"Note_info__Din6R","note":"Note_note__1M8C0","actions":"Note_actions__RoOB6"};